import { Component, OnInit, input } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-key-input-app-settings-form',
  templateUrl: './key-input-app-settings-form.component.html',
  styleUrls: ['./key-input-app-settings-form.component.css']
})
export class KeyInputAppSettingsFormComponent implements OnInit {

  constructor() { }

  readonly group = input.required<any>();
  readonly index = input.required<number>();
  readonly array = input.required<FormArray>();
  public isEditing!: boolean 
  ngOnInit(): void {} 

  public removeField(index: number): void {    
    this.array().removeAt(index)
    this.array().markAsDirty()
  }

}
